<template>
  <div
    class="w-full h-full bg-surface-primary rounded-md px-24 lg:px-24 pt-24 pb-16 md:px-93"
  >
    <FamilyDiscountLabels :in-drawer="false" :existing-customer="false" />
    <div class="mb-32">
      <p class="heading-xxs">Redan Halebop-kund med 20 GB+?</p>
      <div class="flex flex-row">
        <NuxtLink
          to="#"
          @click.prevent="
            () => {
              familyStore.addExistingCustomer();
            }
          "
        >
          Logga in för att lägga till familjemedlem
        </NuxtLink>
        <NuxtLink
          v-if="isTestEnvironment()"
          to="#"
          class="ms-8 text-surface-warning"
          @click.prevent="
            () => {
              familyStore.bankIdTestPassthrough();
            }
          "
        >
          TEST
        </NuxtLink>
      </div>
    </div>

    <FamilySectionDataAllowance
      legend="Välj surfmängd för varje person"
      class="mb-16"
    />

    <FamilyConfigurationToggleBindingPeriod class="mb-16" />

    <div class="flex flex-row justify-between">
      <p class="heading-xs pb-16">Huvudabonnemang</p>
      <FamilyConfigurationPriceTextDisplay
        :price="`${parentPlanMonthlyPrice}`"
        :regular-price="`${parentPlanRegularMonthlyPrice || ''}`"
      />
    </div>
    <FamilyConfigurationAddConnections class="py-16" />
    <AppUsp :items="uspItems" usp-direction="col" />
  </div>
</template>

<script lang="ts" setup>
import { isTestEnvironment } from '~/utils/general/isTestEnvironment';
const familyStore = useFamilyStore();
const familyDrawerOpenedWatchable = computed(
  () => familyStore.ui.showFamilyDrawer,
);

const parentPlanMonthlyPrice = computed(
  () => familyStore.selectedParentPlanBundlePrice?.Plan?.MonthlyFee ?? 0,
);

const parentPlanRegularMonthlyPrice = computed(
  () => familyStore.selectedParentPlanBundlePrice?.Plan?.RegularMonthlyFee ?? 0,
);

const uspItems = computed(() => {
  return [
    {
      Icon: 'info',
      Label: 'Är ni fler i familjen?',
      SubLabel:
        'Du kan lägga till två familjeanslutningar i taget. Du kan totalt ha 4 st anslutningar (Halebop familj och Surfsim).',
    },
    {
      Icon: 'coin',
      Label: `Abonnemangens totala kostnad: ${familyStore.summary_totalMontlyCost} kr/mån`,
      SubLabel: familyStore.summary_plansToPurchaseText,
    },
  ];
});

watch(familyDrawerOpenedWatchable, (value, prevValue) => {
  if (prevValue === true && value === false) {
    familyStore.resetToNewCustomerFlowOnFamilyPage();
  }
});
</script>
